export const router = {
  HOME: '/',
}
